var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_592_12237)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10003 1.35986C9.39827 1.35986 9.64003 1.60163 9.64003 1.89986V10.1962L12.3182 7.51802C12.5291 7.30713 12.871 7.30713 13.0818 7.51802C13.2928 7.72891 13.2928 8.07081 13.0818 8.2817L9.48187 11.8817C9.27098 12.0926 8.92908 12.0926 8.71819 11.8817L5.11819 8.2817C4.9073 8.07081 4.9073 7.72891 5.11819 7.51802C5.32908 7.30713 5.67098 7.30713 5.88187 7.51802L8.56003 10.1962V1.89986C8.56003 1.60163 8.80179 1.35986 9.10003 1.35986ZM3.09997 12.0999C3.43134 12.0999 3.69997 12.3686 3.69997 12.6999V14.4999C3.69997 15.1646 4.23475 15.6999 4.89559 15.6999H13.3014C13.9634 15.6999 14.5 15.1632 14.5 14.4999V12.6999C14.5 12.3686 14.7686 12.0999 15.1 12.0999C15.4313 12.0999 15.7 12.3686 15.7 12.6999V14.4999C15.7 15.8248 14.6274 16.8999 13.3014 16.8999H4.89559C3.5682 16.8999 2.49997 15.8235 2.49997 14.4999V12.6999C2.49997 12.3686 2.7686 12.0999 3.09997 12.0999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_592_12237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading);
export default __webpack_public_path__ + "static/media/Icon_loading.6815eb3ee97f693a529ec71144f18500.svg";
export { ForwardRef as ReactComponent };